import util from '../util'

let base = window.$servicePath

export default {
  /**
   * 获取服务器ID
   */
  reqGenerateId() {
    return util.ajax(`${base}/api/app/generateId`)
  },

  invoke(url,...args) {
    let $$$url='';
    if(url.startsWith("#")){
      $$$url=url.substring(1);
    }else{
      if(url.indexOf('?')>-1){
        $$$url='cheetah/service/'+url+'&$$forceTran=false'
      }else{
        $$$url='cheetah/service/'+url+'?$$forceTran=false'
      }
    }
    return util.ajax(`${base}/${$$$url}`,...args)
  },

  invokeInner(url,...args) {
    let $$$url='';
    if(url.startsWith("#")){
      $$$url=url.substring(1);
    }else{
      if(url.indexOf('?')>-1){
        $$$url='cheetah/service/'+url+'&$$es=true&$$forceTran=false'
      }else{
        $$$url='cheetah/service/'+url+'?$$es=true&$$forceTran=false'
      }
    }
    return util.ajax(`${base}/${$$$url}`,...args)
  },

  ajax(url,...args){
    return util.ajax(`${base}/${url}`,...args)
  }
}



// WEBPACK FOOTER //
// ./src/common/api/com.js